import MobileTitleBar from "components/MobileTitleBar"
import React, { Component } from "react"
import { Container, Image } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import Slider from "components/Slider/Slider"

export default class HomePageV2 extends Component {

    render() {
        console.log("shop", shop)
        return (
            <div>
                <WordPressContainer slug="startseite"/>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/pages/HomePageV2.js